import { EditorState } from 'prosemirror-state'
import { MarkType } from 'prosemirror-model'

export const isMarkActive = (state: EditorState, type: MarkType) => {
  let { $from, empty, ranges } = state.selection

  if (empty) return !!type.isInSet(state.storedMarks || $from.marks())
  else return ranges.some(({ $from: { pos: from }, $to: { pos: to } }) => state.doc.rangeHasMark(from, to, type))
}
